<template>
  <div>
    <Echart
      :options="options"
      :id="cdata.id"
      :height="curHeight+'px'"
      :width="curWidth+'px'"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import {getSizeByScreen} from '@/utils/index'

export default {
  data () {
    return {
      options: {},
      curHeight:'',
      curWidth:''
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: String,
      default: '240'
    },
    height: {
      type: String,
      default: '150'
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options = {
          color:['#1083F9', '#FFFA6D', '#7500F3','#77E8A9'],
          tooltip: {
              trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            bottom: '15%',
            right:'0%',
            itemWidth:8,
            itemHeight:8,
            textStyle:{
              fontSize:10,
              color: "rgba(255,255,255,0.65)",
            }
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: newData.seriesRadius? newData.seriesRadius:['20%', '60%'],
              center:newData.seriesCenter?newData.seriesCenter:['50%','50%'],
              data:newData.data,
            } 
          ] 
        };
      },
      immediate: true,
      deep: true
    },
    curWidth:{
      handler (newData) {
        this.curWidth = this.width;
        //适配代码
        // this.curWidth = getSizeByScreen(this.width);
      },
      immediate: true,
      deep: true
    },
    curHeight:{
      handler (newData) {
        this.curHeight = this.height;
        //适配代码
        // this.curHeight = getSizeByScreen(this.height);
      },
      immediate: true,
      deep: true
    }
  }
}
</script>